import { defineComponent as r, createBlock as o, openBlock as t, unref as c, mergeProps as p, withCtx as u, createElementVNode as l } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconReassuranceArrowOutlined",
  __name: "IconReassuranceArrowOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (s, e) => (t(), o(c(m), p(n, { "view-box": "0 0 48 48" }), {
      default: u(() => [...e[0] || (e[0] = [
        l("path", { d: "M25.52 22.93c.37 0 .67-.62.67-1.38 0-.76-.3-1.38-.67-1.38-.37 0-.67.62-.67 1.38 0 .76.3 1.38.67 1.38m2.62-3.33c.11.75.49 1.32.86 1.27.41-.05.58-.71.47-1.46-.11-.75-.49-1.32-.86-1.27-.37.05-.58.71-.47 1.46m-6.401 3.688a.272.272 0 0 0-.089.062h.04a.28.28 0 0 0-.13.36 6 6 0 0 0 2.49 2.41 8.462 8.462 0 0 0 1.07.47 7.189 7.189 0 0 0 2.3.37 6.939 6.939 0 0 0 2.26-.4.28.28 0 0 0-.14-.53 8.1 8.1 0 0 1-4.1-.33 7.66 7.66 0 0 1-1.81-1 11.244 11.244 0 0 1-1.59-1.35.272.272 0 0 0-.301-.062" }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M20.4 38a2.832 2.832 0 0 0 1.11.18 2.316 2.316 0 0 0 .37-.03 2.81 2.81 0 0 0 1.38-.57l18.13-13.73a2.89 2.89 0 0 0-.64-5l-21-8.77a2.89 2.89 0 0 0-4 3l.42 3.29-7.6-.48a2.89 2.89 0 0 0-3.05 3.25l1.71 13.23A2.89 2.89 0 0 0 11 34.75l7.22-2.33.42 3.28A2.88 2.88 0 0 0 20.4 38m-.76-2.51L19.06 31l-8.38 2.8a1.9 1.9 0 0 1-2.47-1.56L6.52 19a1.86 1.86 0 0 1 .49-1.47 1.909 1.909 0 0 1 1.5-.59l8.8.55L16.74 13a1.89 1.89 0 0 1 2.6-2l21 8.76A1.89 1.89 0 0 1 40.76 23l-18.1 13.75a1.921 1.921 0 0 1-1.645.321 1.88 1.88 0 0 1-1.375-1.581",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
